import { Dispatch, SetStateAction } from "react";
import { SalesOverviewOptions } from "@/app/types/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const DROP_DOWN_OPTIONS: SalesOverviewOptions[] = [
  { value: "ALL", label: "All Sales" },
  { value: "RETAIL", label: "Retail Sales" },
];

type DropDownProps = {
  selectedSalesOverviewOption: SalesOverviewOptions;
  setSelectedSalesOverviewOption: Dispatch<
    SetStateAction<SalesOverviewOptions>
  >;
};

export default function SalesDropDown({
  selectedSalesOverviewOption,
  setSelectedSalesOverviewOption,
}: DropDownProps) {
  return (
    <Select
      value={selectedSalesOverviewOption.value}
      onValueChange={(val) => {
        const opt = DROP_DOWN_OPTIONS.find((o) => o.value === val);
        if (opt) setSelectedSalesOverviewOption(opt);
      }}
    >
      <SelectTrigger className="h-8 w-36 text-xs">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {DROP_DOWN_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={opt.value} className="text-xs">
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
